import { useState, useEffect, useCallback, useRef, useMemo } from "react";
import HeaderClientes from "components/_refactor/headers/clients";
import { Container, Grid } from "@material-ui/core";
import FilterCard from "components/_refactor/filter-card";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import PeriodField from "components/_refactor/fields/period-field";
import StructureFields from "components/_refactor/fields/structure";
import TableProdutosDesejo from "./components/table-produtos-desejo";
import DialogDetalhesProdutoDesejo from "./components/dialog-detalhes-produto-desejo";
import moment from "moment";
import Api from "lib/api/httpRequestHelper";
import UtilsFncs from "utils/UtilsFncs";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";

const STATUS_OPCOES = [
  { value: "AguardandoEstoque", label: "Aguardando Estoque" },
  { value: "Notificado", label: "Notificado" },
  { value: "Vendido", label: "Vendido" },
  { value: "Expirado", label: "Expirado" },
];

function formatDataBr(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("pt-BR");
}

function mapResultToRow(item) {
  const idProdutoDesejoDigital =
    item.idProdutoDesejoDigital ?? item.IdProdutoDesejoDigital;
  const dataCriacao = item.dataCriacao ?? item.DataCriacao;
  const iso =
    typeof dataCriacao === "string"
      ? dataCriacao
      : dataCriacao != null
        ? String(dataCriacao)
        : "";
  return {
    idProdutoDesejoDigital,
    dataCriacao,
    dataCriacaoFormat:
      iso.length >= 10
        ? `${iso.substring(8, 10)}/${iso.substring(5, 7)}/${iso.substring(0, 4)}`
        : formatDataBr(dataCriacao),
    descricaoProduto:
      item.descricaoProduto ?? item.DescricaoProduto ?? item.Produto ?? "-",
    idProduto: item.idProduto ?? item.IdProduto ?? "",
    nomeLoja: item.nomeLoja ?? item.NomeLoja ?? item.Loja ?? "-",
    idPessoaLoja: item.idPessoaLoja ?? item.IdPessoaLoja,
    nomeCliente: item.nomeCliente ?? item.NomeCliente ?? item.Cliente ?? "-",
    idConsumidorLoja: item.idConsumidorLoja ?? item.IdConsumidorLoja,
    nomeVendedor:
      item.nomeVendedor ?? item.NomeVendedor ?? item.VendedorResponsavel ?? "-",
    idLojaVendedor: item.idLojaVendedor ?? item.IdLojaVendedor ?? null,
    idUsuarioInclusao: item.idUsuarioInclusao ?? item.IdUsuarioInclusao,
    status: item.status ?? item.Status ?? "",
    emailCliente: item.emailCliente ?? item.EmailCliente ?? "",
    imagemProduto: item.imagemProduto ?? item.ImagemProduto ?? "",
    observacoes: item.observacoes ?? item.Observacoes ?? "",
  };
}

function parseDesiredProductsListResponse(response) {
  const success = response?.Success ?? response?.success ?? false;
  const validationMessage =
    response?.ValidationMessage ?? response?.validationMessage ?? "";
  const outer = response?.Result ?? response?.result;

  let items = [];
  let totalRegistros = 0;
  let pagina = null;
  let pageSize = null;
  let totalDePaginas = null;

  if (Array.isArray(outer)) {
    items = outer;
    totalRegistros = outer.length;
  } else if (outer && typeof outer === "object") {
    const inner = outer.Result ?? outer.result;
    items = Array.isArray(inner) ? inner : [];
    totalRegistros =
      outer.TotalRegistros ?? outer.totalRegistros ?? items.length;
    pagina = outer.Pagina ?? outer.pagina ?? null;
    pageSize = outer.PageSize ?? outer.pageSize ?? null;
    totalDePaginas = outer.TotalDePaginas ?? outer.totalDePaginas ?? null;
  }

  return {
    success,
    validationMessage,
    items,
    totalRegistros,
    pagina,
    pageSize,
    totalDePaginas,
  };
}

function normalizeBusca(s) {
  return String(s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

function dedupeClientes(items) {
  const m = new Map();
  for (const c of items) {
    const id = Number(c.IdConsumidorLoja ?? c.IdCliente);
    if (!Number.isNaN(id)) m.set(id, c);
  }
  return Array.from(m.values());
}

function dedupeProdutos(items) {
  const m = new Map();
  for (const p of items) {
    const id = String(p.IdProduto ?? p.id ?? "").trim();
    if (id) m.set(id, p);
  }
  return Array.from(m.values());
}

function filtrarClientesLocal(list, query) {
  const q = normalizeBusca(query).trim();
  if (!q) return list;
  return list.filter((c) => normalizeBusca(c.Cliente).includes(q));
}

function filtrarProdutosLocal(list, query) {
  const q = normalizeBusca(query).trim();
  if (!q) return list;
  return list.filter((p) => normalizeBusca(p.Nome).includes(q));
}

function filtrarVendedoresLocal(list, query) {
  const q = normalizeBusca(query).trim();
  if (!q) return list;
  return list.filter((v) => normalizeBusca(v.Nome).includes(q));
}

export default function ProdutosDesejo() {
  const snackbar = useSnackbar();

  const [structureFilters, setStructureFilters] = useState({});
  const [structureClearFilters, setStructureClearFilters] = useState(false);
  const [searching, setSearching] = useState(false);
  const [detalheSelecionado, setDetalheSelecionado] = useState(null);
  const [periodo, setPeriodo] = useState({
    value: 15,
    label: "Últimos 15 dias",
  });
  const [data, setData] = useState([]);
  const [totalRegistrosLista, setTotalRegistrosLista] = useState(null);
  const [vendedoresList, setVendedoresList] = useState([]);
  const [produtosBase, setProdutosBase] = useState([]);
  const [produtosExtra, setProdutosExtra] = useState([]);
  const [clientesBase, setClientesBase] = useState([]);
  const [clientesExtra, setClientesExtra] = useState([]);

  const [loadingVendedores, setLoadingVendedores] = useState(false);
  const [loadingProdutos, setLoadingProdutos] = useState(false);
  const [loadingClientes, setLoadingClientes] = useState(false);
  const [erroVendedores, setErroVendedores] = useState(false);
  const [erroClientes, setErroClientes] = useState(false);
  const [erroProdutos, setErroProdutos] = useState(false);
  const [inputVendedor, setInputVendedor] = useState("");
  const [inputCliente, setInputCliente] = useState("");
  const [inputProduto, setInputProduto] = useState("");
  const [structureLoading, setStructureLoading] = useState([]);
  const [filter, setFilter] = useState({
    vendedor: null,
    cliente: null,
    produto: null,
    status: null,
    dataInicial: "",
    dataFinal: "",
  });

  const idPessoaLoja =
    structureFilters?.idLojaUnica ??
    (structureFilters?.idLoja
      ? String(structureFilters.idLoja).split(",")[0]
      : null);

  const clientesBaseRef = useRef([]);
  const clientesExtraRef = useRef([]);
  const produtosBaseRef = useRef([]);
  const produtosExtraRef = useRef([]);

  const clientesMerged = useMemo(
    () => dedupeClientes([...clientesBase, ...clientesExtra]),
    [clientesBase, clientesExtra],
  );
  const clientesOptions = useMemo(
    () => filtrarClientesLocal(clientesMerged, inputCliente),
    [clientesMerged, inputCliente],
  );
  const produtosMerged = useMemo(
    () => dedupeProdutos([...produtosBase, ...produtosExtra]),
    [produtosBase, produtosExtra],
  );
  const produtosOptions = useMemo(
    () => filtrarProdutosLocal(produtosMerged, inputProduto),
    [produtosMerged, inputProduto],
  );
  const vendedoresOptions = useMemo(
    () => filtrarVendedoresLocal(vendedoresList, inputVendedor),
    [vendedoresList, inputVendedor],
  );

  useEffect(() => {
    clientesBaseRef.current = clientesBase;
  }, [clientesBase]);
  useEffect(() => {
    clientesExtraRef.current = clientesExtra;
  }, [clientesExtra]);
  useEffect(() => {
    produtosBaseRef.current = produtosBase;
  }, [produtosBase]);
  useEffect(() => {
    produtosExtraRef.current = produtosExtra;
  }, [produtosExtra]);

  const fetchVendedores = useCallback(
    async (idLoja) => {
      if (!idLoja) {
        setVendedoresList([]);
        return;
      }
      setLoadingVendedores(true);
      setErroVendedores(false);
      try {
        const response = await Api.get(
          "seller-list",
          "action",
          `?IdPessoaLoja=${idLoja}`,
          true,
        );
        const raw = response?.Result?.ListaVendedores ?? [];
        const list = raw.map((v) => ({
          id: v.IdLojaVendedor ?? v.IdUsuario,
          IdUsuario: v.IdUsuario,
          IdLojaVendedor: v.IdLojaVendedor,
          Nome: v.Nome ?? "",
        }));
        setVendedoresList(list);
      } catch (err) {
        setErroVendedores(true);
        snackbar.showMessage("Erro ao buscar vendedores.", {
          severity: "error",
        });
        setVendedoresList([]);
      } finally {
        setLoadingVendedores(false);
      }
    },
    [snackbar],
  );

  const produtoFetchSeqRef = useRef(0);

  const mapListaProdutos = useCallback((raw) => {
    return raw.map((p) => {
      const idProduto = p.IdProduto ?? p.Codigo ?? p.id;
      const nome =
        p.Nome ?? p.nome ?? p.DescricaoProduto ?? p.descricaoProduto ?? "";
      return {
        id: idProduto != null ? String(idProduto) : "",
        IdProduto: idProduto != null ? String(idProduto) : "",
        Nome: nome,
      };
    });
  }, []);

  const fetchProdutosInicial = useCallback(
    async (idPessoaLoja) => {
      if (!idPessoaLoja) {
        setProdutosBase([]);
        setProdutosExtra([]);
        return;
      }
      const seq = ++produtoFetchSeqRef.current;
      setLoadingProdutos(true);
      setErroProdutos(false);
      try {
        const query = `?page=0&pageSize=300&order=D`;
        const response = await Api.get(
          `product-list${query}`,
          "product",
          {},
          true,
        );
        if (seq !== produtoFetchSeqRef.current) return;
        const result = response?.Result ?? response;
        const raw = result?.ListaProdutos ?? [];
        setProdutosBase(mapListaProdutos(raw));
        setProdutosExtra([]);
      } catch (err) {
        if (seq !== produtoFetchSeqRef.current) return;
        setErroProdutos(true);
        snackbar.showMessage("Erro ao buscar produtos.", { severity: "error" });
        setProdutosBase([]);
        setProdutosExtra([]);
      } finally {
        if (seq === produtoFetchSeqRef.current) {
          setLoadingProdutos(false);
        }
      }
    },
    [snackbar, mapListaProdutos],
  );

  const fetchProdutosBuscaApi = useCallback(
    async (idPessoaLoja, filterText) => {
      const q = String(filterText || "").trim();
      if (!q) return;
      const seq = ++produtoFetchSeqRef.current;
      setLoadingProdutos(true);
      setErroProdutos(false);
      try {
        const filterParam = `&filter=${encodeURIComponent(q)}`;
        const query = `?page=0&pageSize=300&order=D${filterParam}`;
        const response = await Api.get(
          `product-list${query}`,
          "product",
          {},
          true,
        );
        if (seq !== produtoFetchSeqRef.current) return;
        const result = response?.Result ?? response;
        const raw = result?.ListaProdutos ?? [];
        const list = mapListaProdutos(raw);
        setProdutosExtra((prev) => dedupeProdutos([...prev, ...list]));
      } catch (err) {
        if (seq !== produtoFetchSeqRef.current) return;
        setErroProdutos(true);
        snackbar.showMessage("Erro ao buscar produtos.", { severity: "error" });
      } finally {
        if (seq === produtoFetchSeqRef.current) {
          setLoadingProdutos(false);
        }
      }
    },
    [snackbar, mapListaProdutos],
  );

  const debounceProdutoSearchRef = useRef(null);
  const handleProdutoInputChange = useCallback(
    (_, inputValue) => {
      const v = inputValue ?? "";
      setInputProduto(v);
      if (!v.trim()) {
        setProdutosExtra([]);
      }
      if (!idPessoaLoja) return;
      if (debounceProdutoSearchRef.current)
        clearTimeout(debounceProdutoSearchRef.current);
      debounceProdutoSearchRef.current = setTimeout(() => {
        const q = v.trim();
        if (!q) {
          debounceProdutoSearchRef.current = null;
          return;
        }
        const merged = dedupeProdutos([
          ...produtosBaseRef.current,
          ...produtosExtraRef.current,
        ]);
        const local = filtrarProdutosLocal(merged, q);
        if (local.length > 0) {
          debounceProdutoSearchRef.current = null;
          return;
        }
        fetchProdutosBuscaApi(idPessoaLoja, q);
        debounceProdutoSearchRef.current = null;
      }, 400);
    },
    [idPessoaLoja, fetchProdutosBuscaApi],
  );

  const clienteFetchSeqRef = useRef(0);

  const mapListaClientes = useCallback((raw) => {
    return raw.map((c) => ({
      IdCliente: c.IdConsumidorLoja ?? c.IdConsumidor ?? c.Id,
      IdConsumidorLoja: c.IdConsumidorLoja ?? c.IdConsumidor ?? c.Id,
      Cliente:
        c.Nome ??
        (c.NomeFantasia && c.NomeFantasia !== "-"
          ? c.NomeFantasia
          : `Cliente ${c.IdConsumidorLoja ?? c.Id}`),
    }));
  }, []);

  const fetchClientesInicial = useCallback(
    async (idPessoaLoja) => {
      if (!idPessoaLoja) {
        setClientesBase([]);
        setClientesExtra([]);
        return;
      }
      const seq = ++clienteFetchSeqRef.current;
      setLoadingClientes(true);
      setErroClientes(false);
      try {
        const query = `?idPessoaLoja=${encodeURIComponent(idPessoaLoja)}&page=0&pageSize=2500`;
        const response = await Api.get(
          "customer-list",
          "customer",
          query,
          true,
        );
        if (seq !== clienteFetchSeqRef.current) return;
        const result = response?.Result ?? response;
        const raw = result?.ListaClientes ?? [];
        const list = mapListaClientes(raw);
        setClientesBase(list);
        setClientesExtra([]);
        if (list.length === 0 && response?.ValidationMessage) {
          snackbar.showMessage(response.ValidationMessage, {
            severity: "info",
          });
        }
      } catch (err) {
        if (seq !== clienteFetchSeqRef.current) return;
        setErroClientes(true);
        snackbar.showMessage("Erro ao buscar clientes.", { severity: "error" });
        setClientesBase([]);
        setClientesExtra([]);
      } finally {
        if (seq === clienteFetchSeqRef.current) {
          setLoadingClientes(false);
        }
      }
    },
    [snackbar, mapListaClientes],
  );

  const fetchClientesBuscaApi = useCallback(
    async (idPessoaLoja, nomeFilter) => {
      const q = String(nomeFilter || "").trim();
      if (!q) return;
      const seq = ++clienteFetchSeqRef.current;
      setLoadingClientes(true);
      setErroClientes(false);
      try {
        const nomeParam = `&nome=${encodeURIComponent(q)}`;
        const query = `?idPessoaLoja=${encodeURIComponent(idPessoaLoja)}&page=0&pageSize=500${nomeParam}`;
        const response = await Api.get(
          "customer-list",
          "customer",
          query,
          true,
        );
        if (seq !== clienteFetchSeqRef.current) return;
        const result = response?.Result ?? response;
        const raw = result?.ListaClientes ?? [];
        const list = mapListaClientes(raw);
        setClientesExtra((prev) => dedupeClientes([...prev, ...list]));
        if (list.length === 0 && response?.ValidationMessage) {
          snackbar.showMessage(response.ValidationMessage, {
            severity: "info",
          });
        }
      } catch (err) {
        if (seq !== clienteFetchSeqRef.current) return;
        setErroClientes(true);
        snackbar.showMessage("Erro ao buscar clientes.", { severity: "error" });
      } finally {
        if (seq === clienteFetchSeqRef.current) {
          setLoadingClientes(false);
        }
      }
    },
    [snackbar, mapListaClientes],
  );

  const debounceClienteSearchRef = useRef(null);
  const handleClienteInputChange = useCallback(
    (_, inputValue) => {
      const v = inputValue ?? "";
      setInputCliente(v);
      if (!v.trim()) {
        setClientesExtra([]);
      }
      if (!idPessoaLoja) return;
      if (debounceClienteSearchRef.current)
        clearTimeout(debounceClienteSearchRef.current);
      debounceClienteSearchRef.current = setTimeout(() => {
        const q = v.trim();
        if (!q) {
          debounceClienteSearchRef.current = null;
          return;
        }
        const merged = dedupeClientes([
          ...clientesBaseRef.current,
          ...clientesExtraRef.current,
        ]);
        const local = filtrarClientesLocal(merged, q);
        if (local.length > 0) {
          debounceClienteSearchRef.current = null;
          return;
        }
        fetchClientesBuscaApi(idPessoaLoja, q);
        debounceClienteSearchRef.current = null;
      }, 400);
    },
    [idPessoaLoja, fetchClientesBuscaApi],
  );

  useEffect(() => {
    setInputVendedor("");
    setInputCliente("");
    setInputProduto("");
    setErroVendedores(false);
    setErroClientes(false);
    setErroProdutos(false);
    if (idPessoaLoja) {
      fetchVendedores(idPessoaLoja);
      fetchClientesInicial(idPessoaLoja);
      fetchProdutosInicial(idPessoaLoja);
    } else {
      setVendedoresList([]);
      setClientesBase([]);
      setClientesExtra([]);
      setProdutosBase([]);
      setProdutosExtra([]);
    }
  }, [idPessoaLoja]);

  useEffect(() => {
    return () => {
      if (debounceProdutoSearchRef.current)
        clearTimeout(debounceProdutoSearchRef.current);
      if (debounceClienteSearchRef.current)
        clearTimeout(debounceClienteSearchRef.current);
    };
  }, []);

  useEffect(() => {
    if (!Array.isArray(data) || data.length === 0) return;
    setClientesBase((prev) => {
      const byId = new Map();
      for (const c of prev) {
        const id = Number(c.IdConsumidorLoja ?? c.IdCliente);
        if (!Number.isNaN(id)) byId.set(id, c);
      }
      for (const row of data) {
        const id = Number(row.idConsumidorLoja);
        if (Number.isNaN(id) || byId.has(id)) continue;
        byId.set(id, {
          IdCliente: id,
          IdConsumidorLoja: id,
          Cliente: row.nomeCliente || `Cliente ${id}`,
        });
      }
      return Array.from(byId.values());
    });
  }, [data]);

  const handleDataInicialChange = (value) => {
    setFilter((prev) => ({ ...prev, dataInicial: value || "" }));
  };

  const handleDataFinalChange = (value) => {
    setFilter((prev) => ({ ...prev, dataFinal: value || "" }));
  };

  const handlePeriodoChange = (option) => {
    setPeriodo(option);
    if (option && option.value !== "Outros") {
      const days = Number(option.value);
      const today = moment().format("MM-DD-YYYY");
      const initial = moment()
        .subtract(days - 1, "days")
        .format("MM-DD-YYYY");

      handleDataInicialChange(initial);
      handleDataFinalChange(today);
    } else if (option?.value === "Outros") {
      handleDataInicialChange("");
      handleDataFinalChange("");
    }
  };

  const handleSearch = useCallback(async () => {
    setSearching(true);
    try {
      const params = {};
      const rawIdPessoaLoja =
        structureFilters?.idLojaUnica ??
        (structureFilters?.idLoja
          ? String(structureFilters.idLoja).split(",")[0]
          : null);
      const idPessoaLojaNum =
        rawIdPessoaLoja != null && rawIdPessoaLoja !== ""
          ? Number(rawIdPessoaLoja)
          : null;
      if (idPessoaLojaNum != null && !Number.isNaN(idPessoaLojaNum))
        params.idPessoaLoja = idPessoaLojaNum;
      const idLojaVendedorFiltro =
        filter.vendedor?.IdLojaVendedor ??
        filter.vendedor?.idLojaVendedor ??
        filter.vendedor?.id;
      if (
        idLojaVendedorFiltro != null &&
        !Number.isNaN(Number(idLojaVendedorFiltro))
      ) {
        params.idLojaVendedor = Number(idLojaVendedorFiltro);
      }
      const idConsumidor =
        filter.cliente?.IdCliente ?? filter.cliente?.IdConsumidorLoja;
      if (idConsumidor != null && !Number.isNaN(Number(idConsumidor)))
        params.idConsumidorLoja = Number(idConsumidor);
      const idProduto = filter.produto?.IdProduto ?? filter.produto?.id;
      if (idProduto) params.idProduto = String(idProduto);
      if (filter.status?.value) params.status = filter.status.value;
      const DATE_FORMATS = [
        "MM-DD-YYYY",
        "MM/DD/YYYY",
        "DD/MM/YYYY",
        "DD-MM-YYYY",
        "YYYY-MM-DD",
      ];
      if (filter.dataInicial) {
        let mIni = moment(filter.dataInicial, DATE_FORMATS, true);
        if (!mIni.isValid()) mIni = moment(filter.dataInicial);
        if (mIni.isValid()) params.dataInicio = mIni.format("YYYY-MM-DD");
      }
      if (filter.dataFinal) {
        let mFim = moment(filter.dataFinal, DATE_FORMATS, true);
        if (!mFim.isValid()) mFim = moment(filter.dataFinal);
        if (mFim.isValid()) params.dataFim = mFim.format("YYYY-MM-DD");
      }

      const query = UtilsFncs.RestParamsComposer(params);
      const response = await Api.get(
        "desired-products-list",
        "desiredProducts",
        query || "",
        true,
      );

      const parsed = parseDesiredProductsListResponse(response);
      if (!parsed.success) {
        snackbar.showMessage(
          parsed.validationMessage ||
            "Não foi possível carregar os produtos de desejo.",
          { severity: "warning" },
        );
        setData([]);
        setTotalRegistrosLista(null);
        return;
      }
      const list = parsed.items.map(mapResultToRow);
      setData(list);
      setTotalRegistrosLista(parsed.totalRegistros);
    } catch (err) {
      const msg =
        err?.ErrorMessage ??
        err?.message ??
        String(err ?? "Erro ao buscar produtos de desejo.");
      snackbar.showMessage(msg, { severity: "error" });
      setData([]);
      setTotalRegistrosLista(null);
    } finally {
      setSearching(false);
    }
  }, [filter, structureFilters?.idLojaUnica, snackbar, vendedoresList]);

  const handleStructureFieldsChange = useCallback((values) => {
    setStructureFilters(values || {});
  }, []);

  const handleClearFilters = () => {
    setStructureFilters({});
    setFilter({
      vendedor: null,
      cliente: null,
      produto: null,
      status: null,
      dataInicial: "",
      dataFinal: "",
    });
    setPeriodo(null);
    setData([]);
    setTotalRegistrosLista(null);
    setErroVendedores(false);
    setErroClientes(false);
    setErroProdutos(false);
    setInputVendedor("");
    setInputCliente("");
    setInputProduto("");
    setStructureClearFilters(true);
    setTimeout(() => setStructureClearFilters(false), 300);
  };

  useEffect(() => {
    handlePeriodoChange(periodo);
  }, []);

  async function handleDeleteProdutoDesejo(idProdutoDesejoDigital) {
    try {
      const q = `?idProdutoDesejoDigital=${encodeURIComponent(idProdutoDesejoDigital)}`;
      const response = await Api.deleteParams(
        "desired-products-delete",
        "desiredProducts",
        q,
        true,
      );
      const success = response?.Success ?? response?.success;
      const validationMessage =
        response?.ValidationMessage ?? response?.validationMessage;
      const okMessage = response?.Result?.message ?? response?.result?.message;
      if (success) {
        snackbar.showMessage(
          okMessage || "Produto de desejo excluído com sucesso.",
          { severity: "success" },
        );
        setDetalheSelecionado(null);
        await handleSearch();
      } else {
        snackbar.showMessage(validationMessage || "Não foi possível excluir.", {
          severity: "error",
        });
      }
    } catch (err) {
      const msg =
        err?.ErrorMessage ?? err?.message ?? String(err ?? "Erro ao excluir.");
      snackbar.showMessage(msg, { severity: "error" });
    }
  }

  return (
    <>
      <HeaderClientes section="Produtos Desejo" subsection="Produtos" />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={handleSearch}
          disabled={searching}
          searching={searching}
          handleClearFilters={handleClearFilters}
        >
          <StructureFields
            clearFilters={structureClearFilters}
            onStructureFieldsChange={handleStructureFieldsChange}
            disableAll={!!structureLoading.length}
            onStructureFieldsLoad={setStructureLoading}
            hideFields={[
              "economicGroup",
              "brand",
              "channel",
              "representative",
              "store",
            ]}
            fieldsOrder={["storeSingle"]}
            showSingleStore
          />
          <Grid item xs={12} md={6} lg={2}>
            <AutoCompleteField
              label="Vendedor"
              value={filter.vendedor}
              onChange={(value) =>
                setFilter((f) => ({ ...f, vendedor: value }))
              }
              onInputChange={(_, v) => setInputVendedor(v ?? "")}
              options={vendedoresOptions}
              optionLabelKey="Nome"
              optionIdKey="id"
              disabled={searching || !idPessoaLoja}
              loading={loadingVendedores}
              disableClientFilter
              blockDropdownWhen={
                erroVendedores && !String(inputVendedor || "").trim()
              }
            />
          </Grid>
          <Grid item xs={12} md={6} lg={2}>
            <AutoCompleteField
              label="Cliente"
              value={filter.cliente}
              onChange={(value) => setFilter((f) => ({ ...f, cliente: value }))}
              onInputChange={handleClienteInputChange}
              options={clientesOptions}
              optionLabelKey="Cliente"
              optionIdKey="IdCliente"
              disabled={searching || !idPessoaLoja}
              loading={loadingClientes}
              preserveInputWhenLoading
              disableClientFilter
              blockDropdownWhen={
                erroClientes && !String(inputCliente || "").trim()
              }
            />
          </Grid>
          <Grid item xs={12} md={6} lg={2}>
            <AutoCompleteField
              label="Produto"
              value={filter.produto}
              onChange={(value) => setFilter((f) => ({ ...f, produto: value }))}
              onInputChange={handleProdutoInputChange}
              options={produtosOptions}
              optionLabelKey="Nome"
              optionIdKey="id"
              disabled={searching || !idPessoaLoja}
              loading={loadingProdutos}
              preserveInputWhenLoading
              disableClientFilter
              blockDropdownWhen={
                erroProdutos && !String(inputProduto || "").trim()
              }
            />
          </Grid>
          <Grid item xs={12} md={6} lg={2}>
            <AutoCompleteField
              label="Status"
              value={filter.status}
              onChange={(value) => setFilter((f) => ({ ...f, status: value }))}
              options={STATUS_OPCOES}
              optionLabelKey="label"
              optionIdKey="value"
              disabled={searching}
            />
          </Grid>
          <Grid item xs={12} lg={periodo?.value === "Outros" ? 12 : 4}>
            <PeriodField
              label="Período de criação"
              value={periodo}
              onChange={handlePeriodoChange}
              initialDate={filter.dataInicial}
              finalDate={filter.dataFinal}
              setInitialDate={handleDataInicialChange}
              setFinalDate={handleDataFinalChange}
              disabled={searching}
            />
          </Grid>
        </FilterCard>
        <TableProdutosDesejo
          data={data}
          loading={searching}
          totalRegistros={totalRegistrosLista}
          onViewDetails={(row) => setDetalheSelecionado(row)}
          onResearch={handleSearch}
        />
      </Container>
      <DialogDetalhesProdutoDesejo
        open={!!detalheSelecionado}
        onClose={() => setDetalheSelecionado(null)}
        item={detalheSelecionado}
        onDelete={handleDeleteProdutoDesejo}
      />
    </>
  );
}
